import { emptyValueSpecDraft, valueSpecSummary } from '@/utils/mapperConfigDraft';
import MapperValueSpecForm from './MapperValueSpecForm.vue';
const KIND_ICONS = {
  literal: 'fal fa-quote-left',
  path: 'fal fa-sitemap',
  capture: 'fal fa-hashtag',
  lookup: 'fal fa-table'
};
export default {
  name: 'MapperValueSpecChip',
  components: {
    MapperValueSpecForm
  },
  props: {
    value: {
      type: Object,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    defaultKind: {
      type: String,
      required: false,
      default: 'path'
    },
    optional: {
      type: Boolean,
      required: false,
      default: false
    },
    showLabel: {
      type: Boolean,
      required: false,
      default: true
    },
    captures: {
      type: Array,
      required: false,
      default: () => []
    },
    lookupTables: {
      type: Array,
      required: false,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    dataTest: {
      type: String,
      required: false,
      default: 'mapper-value-spec'
    }
  },
  computed: {
    summary() {
      return valueSpecSummary(this.value);
    },
    kindIcon() {
      return KIND_ICONS[this.summary.kind] || 'fal fa-quote-left';
    }
  },
  methods: {
    createDraft() {
      return emptyValueSpecDraft(this.defaultKind);
    }
  }
};